export function parseTime(timeString, hourFormat) {
    var _a;
    const timeAndPeriod = timeString.split(' ');
    let hours = getTimePart(timeAndPeriod[0]);
    const minutes = getTimePart(timeAndPeriod[0], true) || 0;
    let period = (_a = getPeriod(timeAndPeriod[1])) !== null && _a !== void 0 ? _a : '';
    if (!isValidTime(hours, minutes, timeAndPeriod[0].split(':')[1], period, timeAndPeriod[1])) {
        return { valid: false, timeDisplay: timeString };
    }
    if (hourFormat === '12' && hours > 12) {
        hours -= 12;
        period = 'pm';
    }
    if (hourFormat === '24' && period === 'pm') {
        hours += 12;
    }
    if (!period && hours < 12) {
        period = 'am';
    }
    else if (!period) {
        period = 'pm';
    }
    const periodString = hourFormat === '24' ? '' : ' ' + period;
    return {
        timeDisplay: String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0') + periodString,
        valid: true,
    };
}
function getTimePart(totalTime, getMinutes) {
    const timeParts = totalTime.split(':');
    return Number(timeParts[getMinutes ? 1 : 0]);
}
function getPeriod(rawPeriod) {
    if (typeof rawPeriod === 'string') {
        let period = rawPeriod.split('.').join('');
        period = period.toLowerCase();
        if (period === 'am' || period === 'pm') {
            return period;
        }
    }
    return undefined;
}
function isValidHours(hours) {
    return typeof hours === 'number' && hours >= 0 && hours < 25;
}
function isValidMinutes(minutes) {
    return typeof minutes === 'number' && minutes >= 0 && minutes < 60;
}
function isValidPeriod(period) {
    return period === 'am' || period === 'pm';
}
function isValidTime(hours, minutes, rawMinutes, period, rawPeriod) {
    let validHours = isValidHours(hours);
    // 13:xx am doesn't make sense
    if (period === 'am' && hours > 12) {
        validHours = false;
    }
    // not passing minutes or period is fine
    const validMinutes = !rawMinutes || isValidMinutes(minutes);
    const validPeriod = !rawPeriod || isValidPeriod(period);
    return validHours && validMinutes && validPeriod;
}
